import green from "@material-ui/core/colors/green"
const styles = theme => ({
  card: {
    width: 400,
    position: "relative",
    cursor: "pointer",
    minHeight: 390,
    borderRadius: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      width: 350,
    },
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  title: {
    textAlign: "left",
    flexGrow: 1,
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    paddingTop: theme.spacing(1.5),
    fontSize: "initial",
    fontWeight: 600,
  },
  date: {
    color: "grey",
  },
  formLogo: {
    height: 35,
  },
  representativeLogo: {
    width: "25px",
    height: "25px",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  shootName: {
    fontSize: 15,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  positionName: {
    fontSize: 10,
    // display: "inline-block",
    overflow: "hidden",
    textOverflow: "breakword",
  },
  chipWrapper: {
    position: "absolute",
    top: 0,
    right: theme.spacing(1),
    margin: "16px 0 0 16px",
    textAlign: "right",
  },
  imgWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    margin: "16px 0 0 16px",
    textAlign: "left",
  },
  chip: {
    color: "white",
    cursor: "pointer",
  },
  chipBlue: {
    backgroundColor: theme.palette.primary.main,
  },
  chipYellow: {
    backgroundColor: "#FFB60C",
  },
  chipGreen: {
    backgroundColor: green[400],
  },
  chipRed: {
    backgroundColor: theme.palette.secondary.main,
  },
  chipGrey: {
    backgroundColor: "#9e9e9e",
  },
  chipPurple: {
    backgroundColor: "#966dd3",
  },
  positionAbsolute: {
    width: "35px",
    height: "35px",
    marginRight: theme.spacing(2),
  },
  representativeSection: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(1.5),
  },
})

export default styles
